import { useQuery } from '@tanstack/react-query';
import { reportsApi, ReportsDashboard } from '@/services/reports-api';

// Query key factory
export const reportsQueryKeys = {
  all: ['reports'] as const,
  dashboard: () => [...reportsQueryKeys.all, 'dashboard'] as const,
};

export const useReportsDashboard = () => {
  return useQuery({
    queryKey: reportsQueryKeys.dashboard(),
    queryFn: () => reportsApi.getDashboard().then(r => r.data),
    staleTime: 5 * 60 * 1000, // 5 minutes (align with backend cache TTL)
  });
};
